import React from 'react'
import { Modal, Button, Row, Col } from 'react-bootstrap'

const PodReceipts = ({ show, onHide, documents = [] }) => {
  const docs = documents
  return (
    <Modal show={show} onHide={onHide} size='lg' centered dialogClassName='custom-modal_completed'>
      <Modal.Header closeButton>
        <Modal.Title>POD / Receipts</Modal.Title>
      </Modal.Header>
      <Modal.Body className='custom-modal-body'>
        {docs?.length > 0 ? (
          <Row className='g-0'>
            {docs?.map((doc, index) => (
              <Col key={index} xs={6} className='p-0'>
                <a href={doc?.submitted_attachment_url} target='_blank' rel='noopener noreferrer'>
                  <img
                    src={doc?.submitted_attachment_url}
                    alt={`POD ${index + 1}`}
                    style={{
                      width: '100%',
                      height: '200px',
                      objectFit: 'cover',
                      display: 'block',
                    }}
                  />
                </a>
              </Col>
            ))}
          </Row>
        ) : (
          <p className='text-muted'>No POD/Receipt available.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default PodReceipts
